import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { UserNotificationPreferenceDTO } from "src/models/user-notification-preferences";
import { CurrentUserState } from "./interfaces";
import { CurrentUserAuthorizationDTO } from "../../../../models/auth/current-user-authorization";
import { CompanyAccountDTO } from "../../../../models/company-accounts/company-accounts";
import { CurrentUserDataDTO } from "../../../../models/user";

const initialState: CurrentUserState = {
  isLoggedIn: false,
  authError: "",
  lastRoute: "/",
  currentUserAuthorizations: null,
  currentUserData: null,
  currentCompanyAccount: null,
  providerLogoURL: "",
  currentUserNotificationPreferences: [],
};

export const currentUserSlice = createSlice({
  name: "currentUser",
  initialState,
  reducers: {
    setIsLoggedIn(state, { payload }: PayloadAction<boolean>) {
      state.isLoggedIn = payload;
    },
    setAuthError(state, { payload }: PayloadAction<string>) {
      state.authError = payload;
    },
    setCurrentUserAuthorizations(state, { payload }: PayloadAction<CurrentUserAuthorizationDTO | null>) {
      state.currentUserAuthorizations = payload;
    },
    setCurrentUserData(state, { payload }: PayloadAction<CurrentUserDataDTO | null>) {
      state.currentUserData = payload;
    },
    setCurrentCompanyAccount(state, { payload }: PayloadAction<CompanyAccountDTO | null>) {
      state.currentCompanyAccount = payload;
    },
    setProviderLogoURL(state, { payload }: PayloadAction<string>) {
      state.providerLogoURL = payload;
    },
    setLastRoute(state, { payload }: PayloadAction<string>) {
      state.lastRoute = payload;
    },
    setCurrentUserNotificationPreferences(state, { payload }: PayloadAction<UserNotificationPreferenceDTO[]>) {
      state.currentUserNotificationPreferences = payload;
    },
  },
});

export default currentUserSlice.reducer;
